import { render, staticRenderFns } from "./ruUserProtocol.vue?vue&type=template&id=385fe7ad&scoped=true&"
import script from "./ruUserProtocol.vue?vue&type=script&lang=js&"
export * from "./ruUserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./ruUserProtocol.vue?vue&type=style&index=0&id=385fe7ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385fe7ad",
  null
  
)

export default component.exports